var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"supplier-events"},[_c('KftProductShowcase',{staticClass:"px-md-0",attrs:{"gtm-item-list-id":_vm.gtmItemListId,"products":_vm.konfettiGiftcardEvents,"tags":[]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }